// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2fHnj","errorLogs":"EditorFooter_errorLogs__12yse"};